import { connect } from "react-redux";
import Breadcrumb from "./Breadcrumb";

export default connect((state) => ({
	location: state.router.location,
	/* Notwendig um aus :compressorIndex einen Namen zu machen */
	compressors: state.ablauf.compressors,
	/* Notbehelf für "Umschalten der Sprache erkennen", siehe auch
	 * https://github.com/ratson/react-intl-redux#troubleshooting
	 * Leider ist mir nicht klar, warum ich das nicht auch bei den
	 * anderen Components benötigt habe ...
	 */
	lang: state.current_locale_i18n_key
}))(Breadcrumb);
